import DeleteIcon from "@mui/icons-material/Delete";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import {
  Dialog,
  Stack,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogBody from "../Dialog/Body";
import DialogActionButtons from "../Dialog/Footer";
import DialogHeader from "../Dialog/Header";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const DeleteAlert = forwardRef(({ handleDelete }, ref) => {
  const { t } = useTranslation(["common"]);
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >

      <DialogHeader
        onClose={handleClose}
        title={paramsData?.heading || t("confirmation")}
        secondaryHeading={paramsData?.secondaryHeading || t("deleteConfirmation")}
        icon={<DeleteIcon />}
      />

      <DialogBody>
        <Stack alignItems={"center"} justifyContent={"center"}>
          <ReportGmailerrorredIcon
            htmlColor={"red"}
            sx={{
              fontSize: "5rem",
            }}
          />
        </Stack>
        <Typography variant={"body1"} mt={2.5} textAlign={"center"}>
          {paramsData?.warningText}
        </Typography>
      </DialogBody>

      <DialogActionButtons
        onConfirm={() => handleDelete(paramsData)}
        onCancel={handleClose}
        confirmText={"delete"}
        cancelText={"close"}
      />

    </BootstrapDialog>
  );
});

export default DeleteAlert;
